import { resolveImagePath } from '@/utils/imageMap';

export function MainContent() {
  return (
    <div className="bg-primary-cream">
      {/* Main Content Section */}
      <div className="py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Become a Member Card */}
            <div className="lg:col-span-1">
              <div 
                className="relative h-64 bg-cover bg-center bg-no-repeat rounded-lg overflow-hidden group cursor-pointer"
                style={{
                  backgroundImage: `url(${resolveImagePath('/wp-content/uploads/2017/04/become-a-member.jpg')})`,
                }}
              >
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50 group-hover:bg-opacity-40 transition-all duration-300"></div>
                
                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-6">
                  <h3 className="text-white text-xl font-bold mb-4">Become a Member</h3>
                  <a 
                    href="/membership/"
                    className="inline-block bg-primary-yellow text-black px-6 py-2 rounded font-bold hover:bg-yellow-400 transition-colors"
                    aria-label="Read more about membership options and how to become a member"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>

            {/* Calendar of Events Card */}
            <div className="lg:col-span-1">
              <div 
                className="relative h-64 bg-cover bg-center bg-no-repeat rounded-lg overflow-hidden group cursor-pointer"
                style={{
                  backgroundImage: `url(${resolveImagePath('/wp-content/uploads/2017/03/Calendar-Of-Events-Minute-Man.jpg')})`,
                }}
              >
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50 group-hover:bg-opacity-40 transition-all duration-300"></div>
                
                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-6">
                  <h3 className="text-white text-xl font-bold mb-4">Calendar of Events</h3>
                  <a 
                    href="/calendar/"
                    className="inline-block bg-primary-yellow text-black px-6 py-2 rounded font-bold hover:bg-yellow-400 transition-colors"
                    aria-label="Read more about our calendar of events and scheduled activities"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>

            {/* Facebook and Contact Section */}
            <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Facebook Widget */}
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h3 className="text-xl font-bold text-primary-navy mb-4">Facebook</h3>
                
                {/* Facebook Page Plugin Container */}
                <div className="facebook-plugin-container">
                  <iframe 
                    src="https://web.facebook.com/v2.9/plugins/page.php?adapt_container_width=true&app_id=&channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df0e57d2f40542e5d8%26domain%3Dminutemansportsmen.com%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fminutemansportsmen.com%252Fffe706fec1af784c6%26relation%3Dparent.parent&container_width=231&height=300&hide_cover=false&href=https%3A%2F%2Fwww.facebook.com%2Fminutemansportsman%2F%3Fref%3Daymt_homepage_panel%26sw_fnr_id%3D2850450582%26fnr_t%3D0&locale=en_US&sdk=joey&show_facepile=true&small_header=false&tabs=timeline"
                    width="100%"
                    height="300"
                    style={{
                      border: 'none',
                      overflow: 'hidden'
                    }}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen={true}
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    title="Facebook Page Plugin"
                    className="rounded"
                  />
                </div>
              </div>

              {/* Contact Form */}
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h3 className="text-xl font-bold text-primary-navy mb-4">Contact</h3>
                
                <form className="space-y-4">
                  <div>
                    <label htmlFor="fullName" className="block text-sm font-bold text-gray-700 mb-1">
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      placeholder="Full Name"
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary-navy focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-bold text-gray-700 mb-1">
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Phone"
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary-navy focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-1">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email"
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary-navy focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-bold text-gray-700 mb-1">
                      Message <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Message"
                      rows={4}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary-navy focus:border-transparent resize-vertical"
                    />
                  </div>

                  {/* Honeypot field for spam protection */}
                  <div style={{ display: 'none' }}>
                    <label htmlFor="twitter">X/Twitter</label>
                    <input
                      type="text"
                      id="twitter"
                      name="twitter"
                      tabIndex={-1}
                      autoComplete="off"
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-primary-navy text-white font-bold py-2 px-4 rounded hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-navy focus:ring-offset-2"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Message Section */}
      <div className="bg-primary-navy text-white py-8 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-lg">
            All shotgun enthusiasts should come out for a visit and consider applying for membership. 
            Our facility is focused on the needs of the shotgun sportsman and throws some of the best 
            clay targets in the northeast.
          </p>
        </div>
      </div>
    </div>
  );
}